import React, {useState, useEffect} from 'react';
import {InputNumber} from 'antd';

const Index = (props)=>{
  const {onChange, value} = props;

  const [input, setInput] = useState('');

  useEffect(()=>{
    if(!isNaN(Number(value))) {
      setInput((Number(value) / 100).toFixed(2));
    }
  }, [value]);

  const onInputChange = (e)=>{
    if(e === null) {
      e = '';
    }

    let result = String(e).replace(/\.(\d\d).*$/, '.$1');
    setInput(result);
    if(!isNaN(Number(result))) {
      onChange((Number(result) * 100).toFixed(0));
    }
  }

  return <InputNumber {...props} value={input} onChange={onInputChange} />;
};

export default Index;



// WEBPACK FOOTER //
// ./src/components/Select/Price.js